import {ActionMenu, ThemeProvider} from '@primer/react-brand'
import editors from '@github-ui/global-copilot-menu/editors'

import AzureDataStudioIcon from '../_assets/ide-icons/azure.svg'

const allEditors = {
  ...editors,
  azure_data_studio: {
    name: 'Azure Data Studio',
    url: 'https://learn.microsoft.com/en-us/azure-data-studio/extensions/github-copilot-extension-overview',
    icon: AzureDataStudioIcon,
  },
}

export type IdeLinks = Partial<Record<keyof typeof allEditors, string>>

type Props = {
  deepLinks?: IdeLinks
}

export default function IdeCta({deepLinks}: Props) {
  return (
    <ThemeProvider
      colorMode="light"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <ActionMenu mode="split-button">
        <ActionMenu.Button
          variant="subtle"
          as="a"
          href={deepLinks?.vscode || allEditors.vscode.url}
          leadingVisual={<img src={allEditors.vscode.icon} alt={allEditors.vscode.name} width="10" height="10" />}
        >
          Install Copilot for Visual Studio Code
        </ActionMenu.Button>
        <ActionMenu.Overlay aria-label="Alternative actions">
          {Object.entries(allEditors).map(([editor, {name, url, icon}]) => {
            return (
              <ActionMenu.Item
                key={editor}
                as="a"
                href={deepLinks?.[editor as keyof typeof allEditors] || url}
                leadingVisual={<img src={icon} alt={name} width={16} height={16} />}
              >
                <span style={{whiteSpace: 'nowrap'}}>{name}</span>
              </ActionMenu.Item>
            )
          })}
        </ActionMenu.Overlay>
      </ActionMenu>
    </ThemeProvider>
  )
}

try{ IdeCta.displayName ||= 'IdeCta' } catch {}